export default __webpack_public_path__ + "static/media/yellow_rocket.7b769202.svg";